<template>
  <div class="awarded-page">
    <img class="awarded-image" src="../assets/img/获奖名单.jpg" alt="获奖名单" height="4776" width="1920"/>
  </div>
</template>

<script>
export default {
  name: "Awarded"
}
</script>

<style scoped>
.awarded-page {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
}

.awarded-image {
  width: 100%;
  max-width: 1920px;
  height: auto;
  display: block;
}

</style>
